module.exports = __webpack_public_path__ + "media/ingredients/beans--brown-e651a47d.svg";